( function () {
	'use strict';

	function reverseArr () {
		return function ( arr ) {
			if ( arr ) {
				return arr.slice().reverse();
			}
		};
	}

	angular
		.module( 'app.components' )
		.filter( 'reverseArr', reverseArr );

	reverseArr.$inject = [ '$q', 'coreservice' ];
} )( );
